class FormCheckbox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const checkBoxes = document.querySelectorAll('.mwform-checkbox-field-text');

    // 2番目の要素に対して変更を加える
    if (checkBoxes.length > 16) {
      checkBoxes[16].innerHTML = '<a href="https://dokusogan.jp/yamatei/privacy-policy/" name="consent" target="_blank" class="policy-link">「プライバシーポリシー」</a>に同意する';
    }
  }
}
